module.exports = __webpack_public_path__ + "static/media/rush.232f72b3.png";